export const getIconNameByValue = (value: any) => {
  if (value === 'checked') {
    return 'check';
  }

  if (value === 'partiallyChecked') {
    return 'minus';
  }
};

export const getCheckValue = (propertiesByCategory: any) => {
  if (propertiesByCategory.every((property: any) => property.check)) {
    return 'checked';
  }

  if (propertiesByCategory.some((property: any) => property.check)) {
    return 'partiallyChecked';
  }

  return 'none';
};
